var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"coupon-list"},_vm._l((_vm.coupons),function(coupon){return _c('li',[_c('Coupon',{key:coupon.id,attrs:{"coupon":coupon}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }